import each from 'lodash/each';

import { CampaignModel } from './models';

export class CampaignsCollection {
  constructor(responseItems, domain) {
    let campaigns = [];

    each(responseItems, item => campaigns.push(new CampaignModel(item, domain)));

    this.campaigns = campaigns;
  }
};